import { Scale, ShieldAlert } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
export default function LiabilityAndJurisdiction() {
  return <section id="liability-and-jurisdiction" className="bg-background text-foreground pt-16 md:pt-24 pb-[120px]">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-20">
          {}
          <div className="flex flex-col space-y-6">
            <h2 className="h3 text-foreground/90 flex items-center gap-3">
              <ShieldAlert className="w-7 h-7 text-primary" aria-hidden="true" />
              Liability
            </h2>
            <Alert className="border-primary border-2 shadow-sm bg-background">
              <AlertTitle className="text-lg font-bold text-foreground mb-2">
                Silent Operator Disclaimer
              </AlertTitle>
              <AlertDescription className="text-base leading-relaxed text-muted-foreground">
                Our platform operates strictly as a 'Silent Operator'. We provide
                the technological infrastructure and tools for your business
                operations. However, we assume no liability for the specific
                content, client agreements, or any disputes arising from the
                services you provide using our platform. Use of the platform is
                at your own discretion and risk.
              </AlertDescription>
            </Alert>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h2 className="h3 text-foreground/90 flex items-center gap-3">
              <Scale className="w-7 h-7 text-primary" aria-hidden="true" />
              Jurisdiction
            </h2>
            <div className="flex flex-col space-y-4">
              <p className="body-text text-muted-foreground leading-relaxed">
                These terms, conditions, and any ensuing operational agreements
                are governed by and construed in accordance with the laws of{" "}
                <strong className="text-foreground font-semibold">
                  England and Wales
                </strong>
                .
              </p>
              <p className="body-text text-muted-foreground leading-relaxed">
                Any disputes or claims arising out of or in connection with the
                use of this platform shall be subject to the exclusive
                jurisdiction of the courts of England and Wales. For more
                detailed information regarding your rights and responsibilities,
                please review our complete{" "}
                <Link to="/TermsPage" className="font-semibold text-foreground hover:text-primary transition-colors duration-300 relative inline-block after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-full after:origin-bottom-right after:scale-x-0 after:bg-primary after:transition-transform after:duration-300 hover:after:origin-bottom-left hover:after:scale-x-100">
                  Terms of Service
                </Link>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}